export default [
  { value: '', text: '-- Select condition --' },
  { value: 'alive', text: 'Alive' },
  { value: 'dead', text: 'Dead' },
  { value: 'sick', text: 'Sick' },
  { value: 'frozen', text: 'Frozen' },
  { value: 'preserved', text: 'Preserved' },
  { value: 'inadequate', text: 'Inadequate' },
];
